import React from "react";
import { Modal } from "../../../secondary";
import style from "../woundAssessment.module.scss";
import { Button } from "../../../primary";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAssessmentHistory, setDetailAssessment, setWoundAssessment } from "../../../../app/patientSlice";
import { useAdminView } from "../../../../hooks/useAdminView";

const RevalMergeModal = ({ isModalOpen, setIsModalOpen, assessmentId }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { patientId } = useParams();
  const isAdminView = useAdminView();

  const onClickYesConfirmNavigateMergeWound = () => {
    navigate(`/patients/${patientId}/assessment/${assessmentId}/mergewoundassessment`, {
      state: isAdminView,
    });
    dispatch(setDetailAssessment({}));
    dispatch(setAssessmentHistory({}));
    dispatch(setWoundAssessment("reset"));
  };
  return (
    <Modal
      modalOpen={isModalOpen}
      modalClose={() => setIsModalOpen(false)}
      heading={""}
      className={`${style.modal_box_Merge_Confirmation}`}
      modalSize={`${style.custom_modal_size_Merge_Confirmation}`}
      reset={() => setIsModalOpen(false)}
    >
      <div className={`${style.createManualPopup}`}>
        <h1>This wound has multiple assessments, Do you wish to merge all assessments for this wound?</h1>

        <div className={`d-flex justify-content-center align-items-center text-center pt-3`}>
          <Button
            classes={{ className: `btn ${style.btn_custom} ${style.btn_small_cancel} mr-4` }}
            type="button"
            onClick={() => setIsModalOpen(false)}
          >
            {"No"}
          </Button>
          <Button
            classes={{ className: `btn ${style.btn_custom} ${style.btn_small}` }}
            type="Save"
            onClick={() => onClickYesConfirmNavigateMergeWound()}
          >
            {"Yes"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RevalMergeModal;